import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class PublicationRecord extends PureComponent {
  render() {
    const WIDTH = 216;
    const HEIGHT = 168;

    const {
      publication: {
        id,
        name,
        image_retina: imageRetina,
        image_default: imageDefault,
        research_type_name: researchType,
        url,
      },
    } = this.props;

    return (
      <div className="m-record-results__item">
        {(imageRetina || imageDefault) && (
          <figure className="m-record-results__figure">
            <a
              href={url}
              className="m-image-link m-record-results__image-link"
              aria-hidden="true"
            >
              <div className="m-image">
                <img
                  className="m-image__img m-record-results__img"
                  src={imageDefault}
                  srcSet={`${imageRetina} ${
                    WIDTH * 2
                  }w, ${imageDefault} ${WIDTH}w`}
                  sizes={`(max-width: 620px) 148px, 100vw`}
                  width={WIDTH}
                  height={HEIGHT}
                  alt={""}
                  loading="lazy"
                />
              </div>
            </a>
          </figure>
        )}
        <div className="m-record-results__body">
          {researchType && (
            <div className="t-copy-label m-record-results__label">
              {researchType}
            </div>
          )}
          {name && <p className="m-record-results__text">{name}</p>}
          {url && <a href={url}>Read More</a>}
        </div>
      </div>
    );
  }
}

PublicationRecord.propTypes = {
  publication: PropTypes.object,
};

export default PublicationRecord;
